import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import {TransitionProps} from "@mui/material/transitions";
import {useRecoilState} from "recoil";
import {extraAlertStateAtom} from "../Recoil/Atom/AlertAtom";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const MWExtraAlert = () => {
  const [extraAlertState, setExtraAlertState] = useRecoilState(extraAlertStateAtom);

  const handleClickOpen = () => {
    setExtraAlertState({...extraAlertState, toggle: true});
  };
  const handleClose = () => {
    setExtraAlertState({...extraAlertState, toggle: false});
  };
  return (
    <div>
      <Dialog
        open={extraAlertState.toggle}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
      >
        <DialogTitle>
          {extraAlertState.title ? extraAlertState.title : "EXCEL파일 불러오기"}
        </DialogTitle>
        <DialogContent>{extraAlertState.message}</DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>확인</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MWExtraAlert;
